import moment from 'moment';
// Straight from i18n/locales, NOT from utils: combineReducers calls this reducer
// while the utils <-> store import cycle is still loading, and utils bindings
// would be uninitialised at that moment. locales.js is cycle-free.
import { getDefaultLocale } from '../i18n/locales';

const defaultState = {
  locale: getDefaultLocale(),
  messages: null
};

export default function i18nReducer(state = defaultState, action) {
  switch (action.type) {
    case 'SET_LANGUAGE': {
      moment.locale(action.payload.locale);

      return {
        ...state,
        locale: action.payload.locale,
        messages: action.payload.messages
      };
    }

    default:
      return state;
  }
}
